import type { Banner, ServedAd } from "@/api/types";
import { useServedAds } from "@/features/ads/api";
import { HeroCarousel, type HeroSlide } from "./HeroCarousel";

function toSlide(ad: ServedAd): HeroSlide {
  return {
    id: ad.token.slice(-24),
    title: ad.headline || ad.advertiser,
    subtitle: ad.body,
    image: ad.image,
    mobile_image: ad.mobile_image || ad.image,
    cta_label: ad.cta_label || "Shop now",
    cta_url: ad.cta_url,
    accent: "",
    token: ad.token,
    ad,
  };
}

/** Home hero: a takeover (if booked) replaces the carousel; otherwise ads slot in after the first banner. */
export function HomeHero({
  banners,
  stateId,
  framed,
  fill,
}: {
  banners: Banner[];
  stateId: number | null;
  framed?: boolean;
  fill?: boolean;
}) {
  const takeover = useServedAds("HOME_TAKEOVER", { limit: 1, state: stateId ?? undefined });
  const hero = useServedAds("HOME_HERO", { limit: 3, state: stateId ?? undefined });
  if (takeover.data?.length) return <HeroCarousel banners={[toSlide(takeover.data[0]!)]} framed={framed} fill={fill} />;
  const ads = (hero.data ?? []).filter((a) => a.image || a.kind === "VIDEO").map(toSlide);
  const slides: HeroSlide[] = [...banners];
  ads.forEach((ad, i) => slides.splice(Math.min(1 + i * 2, slides.length), 0, ad));
  return <HeroCarousel banners={slides} framed={framed} fill={fill} />;
}
